export default "__VITE_ASSET__947dfe56__"